import { useState, useRef } from "react"
import PlayButton from "public/assets/play.svg"
import cn from "classnames"
import { getStoryblokLink } from "utilities/getStoryblokLink"
import Placeholder from "public/assets/footer-logo.svg"

export default function DynamicVideo({ component, ...videoFields }) {
  switch (component) {
    case "video_embed":
      return <VideoEmbed {...videoFields} />
    case "yt_embed":
      return <YTEmbed {...videoFields} />
    case "vimeo_embed":
      return <VimeoEmbed {...videoFields} />
    default:
      return "Invalid video type"
  }
}

function VideoEmbed({ video_asset, thumbnail }) {
  const [videoPlaying, setVideoPlaying] = useState(false)
  const videoRef = useRef(null)

  let type = `video/${video_asset.filename.match(/.(mov|mp4)/gi)[0]}`.replace(".", "")
  switch (type) {
    case "video/mov":
      type = "video/mp4"
      break
    case "video/mp4":
      type = "video/mp4"
      break
    default:
      type = "invalid"
      break
  }

  return (
    <div className="relative mx-auto pb-4">
      <button
        onClick={() => {
          setVideoPlaying(!videoPlaying)
          videoPlaying === true ? videoRef.current.pause() : videoRef.current.play()
        }}
        className={cn("absolute top-1/2 left-1/2 scale-75 sm:scale-100 -translate-y-1/2 -translate-x-1/2 z-10", {
          hidden: videoPlaying,
        })}
        title="Play video"
      >
        <PlayButton className="play-video" />
      </button>
      <video
        ref={videoRef}
        poster={thumbnail.filename}
        src={video_asset.filename}
        className="video-embed w-full aspect-video object-cover"
        type={type}
        controls
        onPlay={() => setVideoPlaying(true)}
        onPause={() => setVideoPlaying(false)}
      />
    </div>
  )
}

const IframeVideoStyles = "aspect-video cursor-pointer w-full object-cover pb-4"

function YTEmbed({ id }) {
  const [videoPlay, setVideoPlay] = useState(false)

  return !videoPlay ? (
    <>
      <div className="youtube-thumbnail relative cursor-pointer z-10" onClick={() => setVideoPlay(true)}>
        <Placeholder className="aspect-video bg-blue-light px-12" />
        <PlayButton
          className="play-video absolute scale-75 sm:scale-100 top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 cursor-pointer"
          title="Play video"
        />
      </div>
      <button className="sr-only" onClick={() => setVideoPlay(true)}>
        Load YouTube Video
      </button>
    </>
  ) : (
    <iframe
      className={cn(IframeVideoStyles, "youtube-iframe")}
      src={`https://www.youtube.com/embed/${id}?autoplay=1&mute=1`}
      allowFullScreen
      autoPlay
    />
  )
}

function VimeoEmbed({ src }) {
  const [videoPlay, setVideoPlay] = useState(false)

  return !videoPlay ? (
    <>
      <div className="vimeo-thumbnail relative cursor-pointer z-10" onClick={() => setVideoPlay(true)}>
        <Placeholder className="aspect-video bg-blue-light px-12" />
        <PlayButton
          className="play-video absolute scale-75 sm:scale-100 top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 cursor-pointer"
          title="Play video"
        />
      </div>
      <button className="sr-only" onClick={() => setVideoPlay(true)}>
        Load Vimeo Video
      </button>
    </>
  ) : (
    <iframe
      className={cn(IframeVideoStyles, "vimeo-iframe")}
      src={`${getStoryblokLink(src)}&autoplay=1`}
      allowFullScreen
      allow="autoplay"
    />
  )
}
